import { Component } from '@angular/core';
import { MenuComponent } from '../../layout/menu/menu.component';

@Component({
  selector: 'app-cloud',
  imports: [

    MenuComponent


  ],
  templateUrl: './cloud.component.html',
  styleUrl: './cloud.component.css'
})
export class CloudComponent {

}
